import { Check } from "lucide-react";

const ITEMS = [
  "Zuverlässig",
  "Gründlich",
  "Professionell",
  "Individuelle Reinigungskonzepte",
  "Persönlicher Ansprechpartner",
  "Flexible Planung",
  "Gebäudereinigung Lehrte",
];

const Row = ({ hidden }) => (
  <div className="flex items-center shrink-0" aria-hidden={hidden}>
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center gap-3 px-8 whitespace-nowrap text-sm font-medium tracking-wide text-white/70">
        <Check className="w-4 h-4 text-conv" strokeWidth={3} />
        {item}
      </span>
    ))}
  </div>
);

export const TrustMarquee = () => (
  <div
    className="bg-navy-900 border-y border-white/5 py-4 overflow-hidden relative"
    data-testid="trust-marquee"
  >
    <div className="marquee-track flex w-max">
      <Row hidden={false} />
      <Row hidden={true} />
    </div>
  </div>
);
